import { Injectable } from '@angular/core';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { Subject } from 'rxjs/internal/Subject';
import { NNotificationModal } from './notification.interfaces';

@Injectable({
    providedIn: 'root'
})
export class NotificationInitiatorService extends AbstractDfModalInitiatorService<NNotificationModal.IModalData> {
    /**
     * Notifiactions subject
     */
    private notifications = new Subject<NNotificationModal.IModalData>();

    listen(cb: (data: NNotificationModal.IModalData) => Promise<any> | void): Promise<void> {
        return new Promise(resolve => {
            this.notifications.subscribe(cb);

            resolve();
        });
    }

    /**
     * Push next notification
     */
    push(data: NNotificationModal.IModalData) {
        this.notifications.next(data);
    }
}
